<template>
	<Button @click="onClick" type="primary" :size="size" :disabled="disabled">
		<template #icon>
			<IconUpload :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconUpload from '../icon/IconUpload.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconUpload
	}
}
</script>
